module.exports = __webpack_public_path__ + "static/media/golf-icon.6e19ee98.svg";